import React from 'react';
import View from './view';
import {Props} from './model';
import {useDispatch, useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../redux/selectors/profile';
import {
  transportCardInfoNewSelector,
  transportCardInfoNewIsLoadedSelector,
} from '../../../../redux/selectors/transportCard';
import {getTransportCardInfoNew} from '../../../../redux/actions/transportCard/cardInfo';

export const ECardInfo = () => {
  const dispatch = useDispatch();
  const holderProfile = useSelector(holderProfileSelector());
  const cardInfoNew = useSelector(transportCardInfoNewSelector);
  const isCardInfoNewLoaded = useSelector(transportCardInfoNewIsLoadedSelector);

  React.useEffect(() => {
    if (!holderProfile?.usc) {
      return;
    }

    const cardNumber = Number(holderProfile.usc);

    dispatch(getTransportCardInfoNew(cardNumber));
  }, [holderProfile?.usc]);

  const viewProps: Props = {
    isLoaded: isCardInfoNewLoaded,
    cardInfoNew,
  };

  return <View {...viewProps} />;
};
